/* =========================================================
   evr-consent.js
   Custom Consent Banner -> Shopify Customer Privacy API
   - Zeigt das eigene Banner nur, wenn Shopify Consent verlangt
     (shouldShowBanner) und meldet die Entscheidung zurueck.
   - Trackt Consent/Deny ueber window.dataLayer (GTM/GA4/Elevar).
   Kategorien-Mapping:
     Personalisierung -> preferences
     Marketing        -> marketing (+ sale_of_data)
     Analysen         -> analytics
   ========================================================= */
(function () {
  'use strict';

  if (document.body.classList.contains('is-webview')) return;

  /* ---- QA-Flag: ?evrconsent=1 markiert Beacon-Events als test:true
     (Session-persistent), ?evrconsent=0 hebt es auf. Steuert NICHT mehr die
     Anzeige — das Banner zeigt sich fuer alle ohne gespeicherte Entscheidung. */
  testGateActive();

  function testGateActive() {
    var search = window.location.search || '';
    try {
      var p = new URLSearchParams(search);
      var v = p.get('evrconsent');
      if (v === '1') { sessionStorage.setItem('evrConsentTest', '1'); return true; }
      if (v === '0') { sessionStorage.removeItem('evrConsentTest'); return false; }
      return sessionStorage.getItem('evrConsentTest') === '1';
    } catch (e) {
      return /[?&]evrconsent=1/.test(search);
    }
  }

  var CATS = ['preferences', 'marketing', 'analytics'];

  // Backend-Beacon ueber den bestehenden Shopify App Proxy (/apps/eversion-backend/*
  // -> eversion-backend). Same-origin -> adblocker-resistent; Signaturpruefung
  // macht das Backend wie bei /contact, /referral etc.
  // Leerstring = Beacon aus (nur dataLayer).
  var BEACON_URL = (window.EVR && window.EVR.consentEndpoint) || '/apps/eversion-backend/consent';

  var root, banner, prefs;
  var impressionSent = false;

  function getCP() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  /* ---- dataLayer ---- */
  function pushDL(obj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
  }

  /* ---- Consent-Status-Signal (z.B. fuer das Erstanalyse-Popup: erst nach
     Banner-Entscheidung zeigen). Race-sicher: Flag + Event. ---- */
  function markResolved() {
    try {
      window.EVR = window.EVR || {};
      if (window.EVR.consentResolved) return;
      window.EVR.consentResolved = true;
      document.dispatchEvent(new CustomEvent('evr:consent:resolved'));
    } catch (e) { /* noop */ }
  }

  /* ---- First-Party Beacon (zuverlaessige Accept/Deny-Zaehlung) ---- */
  function sendBeacon(payload) {
    if (!BEACON_URL) return;
    try {
      payload.ts = Date.now();
      payload.path = window.location.pathname;
      payload.test = sessionStorage.getItem('evrConsentTest') === '1';
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        navigator.sendBeacon(BEACON_URL, new Blob([body], { type: 'application/json' }));
      } else {
        fetch(BEACON_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: body,
          keepalive: true,
          credentials: 'omit'
        });
      }
    } catch (e) { /* never block the UI */ }
  }

  function trackDecision(action, consent) {
    pushDL({
      event: 'cmp_consent',
      cmp_action: action, // 'accept_all' | 'deny_all' | 'save_selection'
      cmp_analytics: !!consent.analytics,
      cmp_marketing: !!consent.marketing,
      cmp_preferences: !!consent.preferences
    });
    sendBeacon({
      type: 'decision',
      action: action,
      analytics: !!consent.analytics,
      marketing: !!consent.marketing,
      preferences: !!consent.preferences
    });
  }

  function trackImpression() {
    if (impressionSent) return;
    impressionSent = true;
    pushDL({ event: 'cmp_banner_shown' });
    sendBeacon({ type: 'impression' });
  }

  /* ---- UI ---- */
  function lockScroll(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
    document.body.style.overflow = on ? 'hidden' : '';
  }

  function openRoot() { root.hidden = false; lockScroll(true); }
  function closeRoot() { root.hidden = true; lockScroll(false); }

  function showBanner() {
    banner.hidden = false;
    prefs.hidden = true;
    openRoot();
    trackImpression();
  }

  function showPrefs() {
    syncChecks();
    banner.hidden = true;
    prefs.hidden = false;
    openRoot();
    trackImpression();
  }

  /* ---- Consent lesen/schreiben ---- */
  function readChecks() {
    var consent = { preferences: false, marketing: false, analytics: false };
    CATS.forEach(function (cat) {
      var el = prefs.querySelector('[data-evr-cat="' + cat + '"]');
      if (el) consent[cat] = el.checked;
    });
    return consent;
  }

  function syncChecks() {
    var cp = getCP();
    var current = (cp && cp.currentVisitorConsent) ? cp.currentVisitorConsent() : null;
    CATS.forEach(function (cat) {
      var el = prefs.querySelector('[data-evr-cat="' + cat + '"]');
      if (!el) return;
      if (current && current[cat]) {
        // 'yes' / 'no' / '' (noch keine Entscheidung)
        el.checked = current[cat] === 'yes' ? true : (current[cat] === 'no' ? false : true);
      } else {
        el.checked = true; // Default: vorausgewaehlt (wie Vorlage)
      }
    });
  }

  // Brueckt unsere Entscheidung in Google Consent Mode (Elevar/GTM-Tags haengen
  // an ad_storage/analytics_storage). Der denied-Default sitzt in theme.liquid.
  function pushConsentMode(analytics, marketing) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('consent', 'update', {
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied',
      analytics_storage: analytics ? 'granted' : 'denied'
    });
  }

  // Beim Laden: vorhandene gueltige Shopify-Entscheidung in Consent Mode spiegeln.
  function syncConsentMode() {
    var cp = getCP();
    var c = (cp && cp.currentVisitorConsent) ? cp.currentVisitorConsent() : null;
    if (!c || !hasDecision()) return;
    pushConsentMode(c.analytics === 'yes', c.marketing === 'yes');
  }

  // Hat der Besucher bereits eine Entscheidung getroffen (persistiert)?
  function hasDecision() {
    var cp = getCP();
    var c = (cp && cp.currentVisitorConsent) ? cp.currentVisitorConsent() : null;
    if (!c) return false;
    return [c.analytics, c.marketing, c.preferences, c.sale_of_data].some(function (v) {
      return v === 'yes' || v === 'no';
    });
  }

  function applyConsent(consent, action) {
    // --- UI ZUERST schliessen + Consent Mode/Tracking SYNCHRON feuern. ---
    // Die Dismissal darf NIE von Shopifys async setTrackingConsent-Callback
    // abhaengen: in Meta/IG/FB In-App-Browsern (Hauptquelle des Traffics) kann
    // setTrackingConsent werfen ODER seinen Callback nie aufrufen (Storage
    // partitioniert / Cookies blockiert). Frueher haengte das Banner dadurch,
    // der Nutzer klickte frustriert nach = die beobachteten Dead Clicks auf dem
    // Overlay + die niedrige Scroll-Tiefe (lockScroll friert die Seite ein).
    closeRoot();
    markResolved(); // Banner ist weg -> abhaengige UI (Popup) darf zeigen
    pushConsentMode(!!consent.analytics, !!consent.marketing);
    trackDecision(action, consent);

    var cp = getCP();
    // Persistenz nicht moeglich -> naechster Besuch fragt erneut. UI ist bereits zu.
    if (!cp || !cp.setTrackingConsent) return;

    try {
      cp.setTrackingConsent(
        {
          analytics: !!consent.analytics,
          marketing: !!consent.marketing,
          preferences: !!consent.preferences,
          sale_of_data: !!consent.marketing
        },
        function (result) {
          // Bei Fehler wird nichts persistiert -> Banner kaeme beim naechsten
          // Besuch wieder. UI ist bereits zu, daher hier nur noch Logging.
          if (result && result.error) {
            console.error('[evr-consent] setTrackingConsent error:', result.error);
          }
        }
      );
    } catch (e) {
      console.error('[evr-consent] setTrackingConsent threw:', e);
    }
  }

  /* ---- Events ---- */
  function onClick(e) {
    var btn = e.target.closest('[data-evr-consent]');
    if (!btn || !root.contains(btn)) return;

    switch (btn.getAttribute('data-evr-consent')) {
      case 'accept-all':
        applyConsent({ preferences: true, marketing: true, analytics: true }, 'accept_all');
        break;
      case 'deny-all':
        applyConsent({ preferences: false, marketing: false, analytics: false }, 'deny_all');
        break;
      case 'save':
        applyConsent(readChecks(), 'save_selection');
        break;
      case 'prefs':
        showPrefs();
        break;
      case 'close':
        // Force-Consent: zurueck zum Banner statt komplett schliessen
        showBanner();
        break;
    }
  }

  /* ---- Init: auf Customer Privacy API warten ---- */
  function whenReady(cb) {
    var cp = getCP();
    if (cp && cp.shouldShowBanner) { cb(); return; }

    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (err) {
          if (!err && getCP() && getCP().shouldShowBanner) cb();
          else poll(cb);
        }
      );
    } else {
      poll(cb);
    }
  }

  function poll(cb) {
    var tries = 0;
    var id = setInterval(function () {
      if (getCP() && getCP().shouldShowBanner) {
        clearInterval(id);
        cb();
      } else if (++tries > 100) { // ~10s
        clearInterval(id);
      }
    }, 100);
  }

  function init() {
    root = document.getElementById('evr-consent');
    if (!root) return;
    banner = document.getElementById('evr-consent-banner');
    prefs = document.getElementById('evr-consent-prefs');
    if (!banner || !prefs) return;

    root.addEventListener('click', onClick);

    // Reopen-Hooks fuer spaeter (z.B. Footer-Link "Cookie-Einstellungen")
    window.evrConsent = { open: showPrefs, openBanner: showBanner };
    document.querySelectorAll('[data-evr-consent-open]').forEach(function (el) {
      el.addEventListener('click', function (ev) { ev.preventDefault(); showPrefs(); });
    });

    whenReady(function () {
      // Anzeige-Signal = currentVisitorConsent (hasDecision). shouldShowBanner()
      // liefert in diesem Setup dauerhaft true -> Banner kaeme bei JEDEM Besuch.
      if (hasDecision()) {
        // Entscheidung gespeichert -> in Consent Mode spiegeln, KEIN Banner.
        syncConsentMode();
        markResolved(); // kein Banner noetig -> abhaengige UI darf sofort zeigen
        return;
      }
      // Keine Entscheidung -> Consent denied, Banner zeigen.
      pushConsentMode(false, false);
      showBanner();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
